/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { tagSchema } from './tag-schema';

export const lawSchoolSchema: z.AnyZodObject = z.object({
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  name: z.string().nullish(),
  tags: z.array(z.lazy(() => tagSchema)).nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type LawSchool = z.infer<typeof lawSchoolSchema>;
